import { createClient } from '@supabase/supabase-js'
import type { Database } from '@/types'

const supabaseUrl = String(import.meta.env.VITE_SUPABASE_URL)
const supabaseAnonKey = String(import.meta.env.VITE_SUPABASE_ANON_KEY)

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase URL or Anon Key is missing. Check your .env file.')
  throw new Error('Supabase configuration is missing')
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey)
